const ClearLoginInfo = () => {
    localStorage.clear('u');
}
export default ClearLoginInfo